module.exports = __webpack_public_path__ + "img/not-authorized-dark.7db8a75c.svg";